export const GLOBAL_DATE_RANGE_TEST_ID = 'global-date-range';

export const GLOBAL_DATE_RANGE_LAST_YEAR_TEST_ID =
  'global-date-range-last-year';

export const GLOBAL_DATE_RANGE_THIS_YEAR_TEST_ID =
  'global-date-range-this-year';
